import taskSandboxCss from '../taskSandbox.module.css'
import LightLayout from '../../../../../shared/Layouts/LightLayout'
import { IImage, ITask } from '../../../../../types/tasks.types'
import css from './nineTypeTask.module.css'
import Textarea from '../../../../../shared/Inputs/Textarea'
import useSandboxTask from '../useSandboxTask'
import PngDropzone from '../../../../../shared/Dropzone/PngDropzone'
import InlineSelect from '../../../../../shared/Inputs/InlineSelect'
import { IOption } from '../../../../../shared/Inputs/Dropdown'
import { useState } from 'react'
import TextOption from '../../TextOption'
import sandboxCss from '../taskSandbox.module.css'
import TextInput from '../../../../../shared/Inputs/TextInput'
import useDraftScale from '../useDraftScale'
import CreateTextOptionModal from '../../CreateTextOptionModal'

interface IProps {
  onDraftTaskChange: <T extends keyof ITask>(value: ITask[T], key: T) => void
}

const options: IOption<'exercise' | 'text'>[] = [
  { value: 'text', title: 'Текст' },
  { value: 'exercise', title: 'Задание' },
]

const NineTypeTask = (props: IProps) => {
  const [selectedSlide, setSelectedSlide] = useState<'exercise' | 'text'>('text')
  const ctrl = useSandboxTask(props.onDraftTaskChange)
  const scaleCtrl = useDraftScale(ctrl.draftTask, ctrl.handleImageScaleChange)

  const renderOptions = () => {
    return ctrl.draftTask.answerOptions.map((option, index) => (
      <TextOption
        option={option}
        index={index}
        key={index}
        onDelete={ctrl.handleOptionDelete}
        onChange={ctrl.handleOptionChange}
      />
    ))
  }

  const renderContent = () => {
    if (selectedSlide === 'text') {
      return (
        <div className="inline-flex-gap">
          <div style={{ width: '60%' }}>
            <Textarea
              placeHolder="Текст"
              value={ctrl.draftTask.description}
              name="description"
              onChange={props.onDraftTaskChange}
            />
          </div>
          <div style={{ width: '40%' }}>
            <TextInput
              inscription="Ширина картинки, %"
              value={scaleCtrl.imageScale}
              name="scale"
              onChange={scaleCtrl.handleChange}
            />
            <div style={{ marginTop: '1em' }} />
            <PngDropzone onFile={ctrl.handleImage} image={ctrl.draftTask.images[0] as IImage} />
          </div>
        </div>
      )
    }

    return (
      <div className="flex-form" style={{ gap: '100px' }}>
        <Textarea
          placeHolder="Вопрос"
          value={ctrl.draftTask.question}
          name="question"
          onChange={props.onDraftTaskChange}
        />
        <div className={css.options}>
          {renderOptions()}
          <div className={sandboxCss.addOption} onClick={ctrl.toggleCreateOptionModal}>
            Добавить карточку
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={taskSandboxCss.wrapper}>
      <LightLayout>
        {ctrl.createOptionModalOpen && (
          <CreateTextOptionModal onClose={ctrl.toggleCreateOptionModal} onCreate={ctrl.handleOptionCreate} />
        )}
        <div className={css.wrapper}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <InlineSelect value={selectedSlide} options={options} onChange={(v) => setSelectedSlide(v)} />
          </div>
          {renderContent()}
        </div>
      </LightLayout>
    </div>
  )
}

export default NineTypeTask
